import React from 'react';
import MViewDetailNotifFormList from './MViewDetailNotifFormList';

function MViewDetailNotifForm(props) {
  const {
    auth,
    scope,
    loading,
    initialValues,
  } = props;

  return (
    <div className='content mx-3 overflow-auto my-3'>
      <div className='c-table'>
        <table className='table is-fullwidth is-bordered is-hoverable is-narrow'>
          <thead>
            <tr>
              <th className='has-text-centered' style={{ width: 30 }}>
                No
              </th>
              <th className='has-text-centered' style={{ width: 200 }}>
                Nama Siswa
              </th>
              <th className='has-text-centered' style={{ width: 200 }}>
                Kelas
              </th>
              <th className='has-text-centered' style={{ width: 150 }}>
                Device
              </th>
            </tr>
          </thead>
          <tbody>
            <MViewDetailNotifFormList
              auth={auth}
              scope={scope}
              loading={loading}
              items={initialValues}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MViewDetailNotifForm;
